import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/course-subjects/CourseSubjectsAction";
import * as uiHelpers from "../CourseSubjectsUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useCourseSubjectsUIContext } from "../CourseSubjectsUIContext";

export function CourseSubjectsTable({ 
  deleteCourseSubjects
}) {
  // Course Subjects UI Context
  const courseSubjectsUIContext = useCourseSubjectsUIContext();
  const courseSubjectsUIProps = useMemo(() => {
    return {
      ids: courseSubjectsUIContext.ids,
      setIds: courseSubjectsUIContext.setIds,
      queryParams: courseSubjectsUIContext.queryParams,
      setQueryParams: courseSubjectsUIContext.setQueryParams,
      openSubjectOutcomeListPage: courseSubjectsUIContext.openSubjectOutcomeListPage,
      openEditCourseSubjectPage: courseSubjectsUIContext.openEditCourseSubjectPage
    };
  }, [courseSubjectsUIContext]);

  // Getting curret state of Course Subjects list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.courseSubjects }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // Course Subjects Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    // clear selections list
    courseSubjectsUIProps.setIds([]);
    // ...
    dispatch(actions.getCourseSubjects(courseSubjectsUIProps.queryParams));
    return () => dispatch(actions.cleanCourseSubjectsState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseSubjectsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "subject",
      text: "Konu",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "200px"
      }
    },
    {
      dataField: "code",
      text: "Kodu",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "120px"
      }
    },
    {
      dataField: "explanation",
      text: "Açıklaması",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "action",
      text: "İşlemler",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        isEditionAuthorized,
        isDeletionAuthorized,
        openSubjectOutcomeListPage: courseSubjectsUIProps.openSubjectOutcomeListPage,
        openEditCourseSubjectPage: courseSubjectsUIProps.openEditCourseSubjectPage,
        deleteCourseSubjects
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-9",
      style: {
        minWidth: "130px",
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: courseSubjectsUIProps.queryParams.pageSize,
    page: courseSubjectsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                courseSubjectsUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: courseSubjectsUIProps.ids,
                setIds: courseSubjectsUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}